import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Foot, { Footer } from '../../components/footer';
import SzHeader from '../../components/szHeader';
import Qrcode from '../../components/qrcode';
import Search from '../../components/search';
import LeftNav from '../../components/leftNav';
import RightOne from '../layout/rightOne';
import RightTwo from '../layout/rightTwo';

import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';

/**
 * for this page
 */

const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };
        state = {
            oneDisplay: true,
            twoDisplay: false,
            threeDisplay: false,
            fourDisplay: false,
            navIndex: 0,
        };
        // 左侧导航点击定位
        handleLeftNav = num => {
            if (num === 0) {
                this.setState({
                    oneDisplay: true,
                    twoDisplay: false,
                    threeDisplay: false,
                    fourDisplay: false,
                });
            } else if (num === 1) {
                this.setState({
                    oneDisplay: false,
                    twoDisplay: true,
                    threeDisplay: false,
                    fourDisplay: false,
                });
            } else if (num === 2) {
                this.setState({
                    oneDisplay: false,
                    twoDisplay: false,
                    threeDisplay: true,
                    fourDisplay: false,
                });
            } else if (num === 3) {
                this.setState({
                    oneDisplay: false,
                    twoDisplay: false,
                    threeDisplay: false,
                    fourDisplay: true,
                });
            }
            this.setState({
                navIndex: num,
            });
        };
        handleName = text => {
            // this.setState({
            //     jobname: text,
            // });
            // this.getSearchData(text, this.state.workplace, this.state.jobType, 1, 10);
            const recruitSearch = window.open('about:blank');

            if (text === undefined) {
                const recruitSearch = window.open('about:blank');

                recruitSearch.location.href = '/pc/career/job/recruit/';
            } else {
                const recruitSearch = window.open('about:blank');

                recruitSearch.location.href = `/pc/career/job/recruit/${text}/`;
            }
        };
        render() {
            const { content } = this.props;

            const { header, qrCodeInfo, leftNav, rightOne, rightTwo, rightThree, rightFour } = content;
            const { oneDisplay, twoDisplay, threeDisplay, navIndex, fourDisplay } = this.state;

            return (
                <div>
                    <div className={styles.col}>
                        <Search handleName={this.handleName} />
                        <SzHeader current={4} content={header} />

                        <div className={`${styles.mid_gy} clearfix`} style={{ marginBottom: '0' }}>
                            <div className={styles.mid_gy_left}>
                                <Chip id="65003" type="struct" title="左侧导航" groupName="关于凤凰" content={leftNav}>
                                    <LeftNav clickHandle={this.handleLeftNav} current={navIndex} />
                                </Chip>
                            </div>
                            <div className={styles.mid_gy_right}>
                                <Chip id="40163" type="static" title="公司介绍" groupName="关于凤凰" content={rightOne}>
                                    <RightOne show={oneDisplay} />
                                </Chip>
                                <Chip id="65005" type="struct" title="产品介绍" groupName="关于凤凰" content={rightTwo}>
                                    <RightTwo show={twoDisplay} />
                                </Chip>
                                <Chip
                                    id="40118"
                                    type="static"
                                    title="企业文化"
                                    groupName="关于凤凰"
                                    content={rightThree}>
                                    <RightOne show={threeDisplay} />
                                </Chip>
                                <Chip
                                    id="40119"
                                    type="static"
                                    title="社会责任"
                                    groupName="关于凤凰"
                                    content={rightFour}>
                                    <RightOne show={fourDisplay} />
                                </Chip>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    <Qrcode content={qrCodeInfo} />
                    <ChipEdit />
                </div>
            );
        }
    },
);

export { Layout };
export default Layout;
